import React from "react";

//MUI
import Slider from "@mui/material/Slider";

function OpacitySlider(props: any) {
  const { checked, handleChange } = props

    return (
        <Slider
          size="medium"
          aria-label="Opacity"
          defaultValue={100}
          valueLabelDisplay="auto"
          min={0}
          max={100}
          disabled={ checked ? false : true }
          onChange={handleChange}
          sx={{
            width: 150,
            mr: 3
          }}
        />
    )
}

export default OpacitySlider